import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedQuota = () => {
  return {
    type: null,
    code: null,
    name: null,
    saleOpen: false,
    saleOpenTime: null,
    active: false,
    agencyId: null,
    scheduleId: null,
    minKm: null,
    maxSeatsInTrain: null,
    fromStationId: null,
    toStationId: null,
    salesChannelIds: [],
    assignToAgencyRole: true,
  };
};

export default {
  state: () => ({
    selectedQuota: getDefaultSelectedQuota(),
    presetQuotaSearch: null,
  }),

  mutations: {
    setSelectedQuota(state, quota) {
      Vue.set(state, "selectedQuota", quota);
    },
    setPresetQuotaSearch(state, presetQuotaSearch) {
      Vue.set(state, "presetQuotaSearch", presetQuotaSearch);
    },
    setDefaultSelectedQuota(state) {
      Vue.set(state, "selectedQuota", getDefaultSelectedQuota());
    },
    setDefaultQuotaModule(state) {
      Vue.set(state, "selectedQuota", getDefaultSelectedQuota());
      Vue.set(state, "presetQuotaSearch", null);
    },
  },

  actions: {
    //TODO: load, update, create
    createQuota: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/quotas/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadQuotas: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
    loadQuota: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/entity/" + request.id, {}).then((response) => {
        context.commit("setSelectedQuota", response.data);
        return response.data;
      });
    },
    loadPublishedQuotas: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/entity/published").then((response) => {
        return response.data;
      });
    },

    findPermittedQuotas: (context) => {
      return axios.get(context.getters.getTmsServiceUrl + "/quotas/find-permitted-quotas").then((response) => {
        return response.data;
      });
    },

    loadSelectedQuotaHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteQuotas: (context, quotas) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/schedule-quotas/batch", { data: quotas })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteTrainQuotas: (context, quotas) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-quotas/batch-delete-train-quotas-by-ids", quotas)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteQuota: (context, quota) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/quotas/entity/" + quota.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          quota.intents = intents;
          quota.intentId = response.data.id;
          return quota;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftQuota: (context, quota) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/quotas/draft/" + quota.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishQuota: (context, quota) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/publish/" + quota.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectQuota: (context, quota) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/reject/" + quota.intentId).then((response) => {
        if (quota.intents[0].type === "DELETE_QUOTA") {
          quota.intents = null;
          quota.intentId = 0;
        } else if (quota.intents[0].type === "CREATE_QUOTA") {
          quota.intents[0].status = "DRAFT";
        } else if (quota.intents[0].type === "UPDATE_QUOTA") {
          quota.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalQuota: (context, quota) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/sendToApproval/" + quota.intentId).then((response) => {
        if (quota.intents[0].type === "CREATE_QUOTA") {
          quota.intents[0].status = "WAITING_APPROVAL";
        } else if (quota.intents[0].type === "UPDATE_QUOTA") {
          quota.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallQuota: (context, quota) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/recall/" + quota.intentId).then((response) => {
        helper.recallOrRejectEntity(quota, "quota");
        return response.data;
      });
    },
    cancelQuota: (context, quota) => {
      return axios.get(context.getters.getMcServiceUrl + "/quotas/cancel/" + quota.intentId).then((response) => {
        return response.data;
      });
    },
    createQuotaSchedules: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/schedule-quotas/create-quota-schedule", request).then((response) => {
        return response.data;
      });
    },
    findQuotaSchedules: (context, request) => {
      return axios.post(context.getters.getTmsServiceUrl + "/quotas/find-quota-schedules", request).then((response) => {
        return response.data;
      });
    },
    findQuotaSchedulesByScheduleId: (context, scheduleId) => {
      return axios.post(context.getters.getTmsServiceUrl + "/quotas/find-quota-schedules-by-schedule-id/" + scheduleId).then((response) => {
        return response.data;
      });
    },
    getSharedTrainCars: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/quotas/get-shared-train-cars", request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          return response.data;
        });
    },
    findTrainsSharedQuotas: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/quotas/find-shared-train-quotas", request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          return response.data;
        });
    },
    findTrainsQuotasByTrainIdsAndQuotaId: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/quotas/find-by-train-ids-and-quota-id", request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          return response.data;
        });
    },
    findTrainsQuotasByTrainIds: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/quotas/find-train-quotas-by-train-ids", request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          return response.data;
        });
    },
    batchCreateTrainQuotas: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-quotas/batch-create-train-quotas", request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          return response.data;
        });
    },
    batchDeleteTrainQuotasByIds: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/train-quotas/batch-delete-train-quotas-by-ids", request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          return response.data;
        });
    },
    loadTrainSegmentInfo: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/train/load-train-segment-info", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {
    getSelectedQuota: (state) => {
      return state.selectedQuota;
    },
    getPresetQuotaSearch: (state) => {
      return state.presetQuotaSearch;
    },
  },
};
